import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetEmailTemplatesRPC } from "./getEmailTemplatesRPC";

export class GetEmailTemplatesRPCClientImpl extends GetEmailTemplatesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetEmailTemplatesRPC.Request): Promise<LeoRPCResult<GetEmailTemplatesRPC.Response, GetEmailTemplatesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetEmailTemplates",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetEmailTemplatesRPC.ResponseDTO,
      GetEmailTemplatesRPC.Errors.ErrorsDTO,
      GetEmailTemplatesRPC.Response,
      GetEmailTemplatesRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetEmailTemplates",
      GetEmailTemplatesRPC.Response.fromDTO,
      GetEmailTemplatesRPC.Errors.fromDTO
    );
  }
}
